import { Checkbox, FormControlLabel } from '@mui/material';
import { forwardRef } from 'react';

export const CheckboxField = forwardRef(({ value, onChange, label, ...props }, ref) => (
  <FormControlLabel
    sx={{ m: 0 }}
    control={
      <Checkbox
        {...props}
        ref={ref}
        checked={Boolean(value)}
        onChange={(event) => onChange(event.target.checked)}
        size="small"
        sx={{ p: 0.5 }}
      />
    }
    label={label}
  />
));

CheckboxField.displayName = 'CheckboxField';
